import React from 'react'
import './PreviewContentLabel.scss'

export default function PreviewContentLabel({ showPublished, previewEnabled }) {
  if (!previewEnabled) return <></>

  if (showPublished)
    return (
      <div className="cannot-edit-wrapper">
        <label className="cannot-edit-label">
        The content you see below is the PUBLISHED CONTENT and every community member using this app see it as is.
        To edit the current PUBLISHED CONTENT you need to set "Display Content as PREVIEW MODE" to Yes and start making changes.
        </label>
      </div>
    )
  else
    return (
      <div className="cannot-edit-wrapper">
        <label className="cannot-edit-label">
        The content you see below is only a PREVIEW MODE and it is not visible for community members using this app.
        This content is only visible for internal users added to the Preview Ability page.
        </label>
      </div>
    )
}
